import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ModeProvider } from "./context/ModeContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import CreateWedding from "./pages/CreateWedding";
import EditWedding from "./pages/EditWedding";
import Dashboard from "./pages/Dashboard";
import PublicWeddings from "./pages/PublicWeddings";
import WeddingDetail from "./pages/WeddingDetail";
import WeddingManage from "./pages/WeddingManage";
import Profile from "./pages/Profile";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ManageRsvp from "./pages/ManageRsvp";
import "./App.css";
import "./brand.css";

const App: React.FC = () => (
  <AuthProvider>
    <ModeProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/my-weddings" element={<Dashboard />} />
            <Route path="/dashboard" element={<Navigate to="/my-weddings" replace />} />
            <Route path="/goer-profile" element={<Navigate to="/profile" replace />} />
            <Route path="/settings" element={<Navigate to="/profile" replace />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/weddings/create" element={<CreateWedding />} />
            <Route path="/weddings/public" element={<PublicWeddings />} />
            <Route path="/weddings/:id/edit" element={<EditWedding />} />
            <Route path="/weddings/:id/manage" element={<WeddingManage />} />
            <Route path="/weddings/:id/rsvp/:rsvpId" element={<ManageRsvp />} />
            <Route path="/weddings/:id" element={<WeddingDetail />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ModeProvider>
  </AuthProvider>
);

export default App;
